<!--
  @description: 首页-待支付合同押金列表组件
  @filePath:src\modules\transport\views\manageDesk\components\NoPaymentContractDepositTable.vue
-->
<template>
  <el-table
    :data="tableData"
    :loading="loading"
    max-height="495"
    empty-text="暂无数据"
    stripe
    show-overflow-tooltip
    class="no-payment-contract-deposit-table"
    style="width: 100%"
  >
    <el-table-column show-overflow-tooltip prop="supCashNo" label="押金单号"></el-table-column>
    <el-table-column show-overflow-tooltip prop="mdcoContractNo" label="合同编号"></el-table-column>
    <el-table-column show-overflow-tooltip prop="budgetAmt" label="押金金额"></el-table-column>
    <el-table-column show-overflow-tooltip prop="paymentAmount" label="已支付金额"></el-table-column>
    <el-table-column label="操作" width="100">
      <template slot-scope="scope">
        <el-button class="bigData-btn-cd-vi" @click="toView(scope.row)" type="text"
          >去查看</el-button
        >
      </template>
    </el-table-column>
    <div slot="empty">
        <img class="img" src="./img/table-empty.png" alt="" />
        <div class="empty-text">暂无数据</div>
    </div>
  </el-table>
</template>

<script>
import { getDepositLists } from '@/modules/transport/bms/api/depositApi';

export default {
    inject: ['linkToPointPage'],
    data() {
        return {
            loading: false,
            tableData: []
        };
    },
    props: {
        tabsCode: {
            type: String,
            default: 'noPaymentContractDeposit'
        }
    },
    mounted() {
        // this.getData();
    },
    methods: {
        toView(row) {
            const pageParams = {
                path: '/bms/deposit',
                query: {
                    supCashNo: row.supCashNo,
                    from: 'todoList'
                }
            };
            this.linkToPointPage && this.linkToPointPage(pageParams);
            this.$emit('toView', row);
        },
        getData() {
            const params = { pageNo: 1, pageSize: 200, statues: '20,30', suppliersCashType: '1' }; // 状态为待支付和部分支付
            this.loading = true;
            getDepositLists(params).then(res => {
                if (res && res.code === '0') {
                    this.tableData = res.data.list.map(item => {
                        // 已支付金额（现汇金额toAmt +应收转押金金额payChangeCashAmt）
                        item.paymentAmount = (item.toAmt + item.payChangeCashAmt) || 0;
                        return item;
                    });
                    this.$emit('dataUpdate', res.data);
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        }
    }
};
</script>

<style lang="less" scoped>
    .no-payment-contract-deposit-table {
        /deep/ .cell {
            line-height: 34px;
        }
        /deep/ th {
            background-color: #f2f3f5;
        }
        /deep/ .el-table__empty-block {
            min-height: 170px !important;
            font-size: 14px;
            color: #4e5969;
            .img {
                width: 110px;
                height: 80px;
                display: block;
                margin: 0 auto;
            }
            .empty-text {
                line-height: 22px;
                margin-top: 8px;
                color: #4E5969;
            }
        }
    }
</style>